import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GufoIcon } from "@/components/GufoIcon";
import { Ghost } from "lucide-react";

function timeAgo(iso) {
  try {
    const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
    if (s < 60) return `${s}s`;
    if (s < 3600) return `${Math.floor(s / 60)}m`;
    if (s < 86400) return `${Math.floor(s / 3600)}h`;
    return `${Math.floor(s / 86400)}g`;
  } catch { return ""; }
}

export default function GufateTicker() {
  const [items, setItems] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/public/gufate?limit=20"); setItems(data); } catch {}
  };
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);

  const loop = items.length > 0 ? [...items, ...items] : [];

  return (
    <div className="relative overflow-hidden rounded-2xl border border-black/40 shadow-lg" style={{ background: "#0a0a0a" }} data-testid="gufate-ticker">
      {/* Breaking news label */}
      <div className="absolute left-0 top-0 bottom-0 z-20 flex items-center px-3 sm:px-5 py-4"
           style={{ background: "linear-gradient(90deg, #f97316 0%, #f97316 92%, transparent 100%)" }}>
        <div className="flex items-center gap-2 text-white">
          <span className="w-2.5 h-2.5 rounded-full bg-white pulse-glow shrink-0" />
          {/* Mobile: 2-line stacked (GUFATE + smaller translucent LIVE) · Desktop: single line */}
          <div className="flex flex-col leading-none sm:hidden">
            <span className="text-[13px] font-black tracking-wider uppercase">GUFATE</span>
            <span className="text-[9px] font-bold tracking-[0.25em] uppercase text-white/60 mt-0.5">LIVE</span>
          </div>
          <span className="hidden sm:inline text-[13px] font-black tracking-widest uppercase">GUFATE LIVE</span>
        </div>
      </div>
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 z-10" style={{ background: "linear-gradient(-90deg, #0a0a0a, transparent)" }} />
      <div className="py-4 pl-24 sm:pl-48 pr-4 whitespace-nowrap">
        {loop.length === 0 ? (
          <div className="flex items-center gap-2 text-white/80 text-base" data-testid="gufate-empty">
            <Ghost className="w-4 h-4" style={{ color: "#f97316" }} />
            Nessuna gufata ancora. Le maledizioni si accendono a breve...
          </div>
        ) : (
          <div className="inline-flex gap-10" style={{ animation: "ticker 79s linear infinite" }}>
            {loop.map((g, i) => (
              <div key={`${g.id || i}-${i}`} className="flex items-center gap-2.5 text-base">
                <Ghost className="w-5 h-5 shrink-0" style={{ color: "#f97316" }} />
                <span className="text-white/90">
                  <b className="text-white">{g.from_team_name || g.from_name}</b>{" "}
                  <span className="text-white/85">{g.line}</span>{" "}
                  <b style={{ color: "#fb923c" }}>{g.target_team || g.target_name}</b>
                  {g.message ? <span className="text-white/70"> — “{g.message}”</span> : null}
                </span>
                <span className="text-white/60 text-sm">· {timeAgo(g.created_at)}</span>
                <GufoIcon size={17} />
              </div>
            ))}
          </div>
        )}
      </div>
      <style>{`@keyframes ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}
